export { default as default } from './Enllac';
